export const LB_LEND = "POPUP/LB_LEND";
export const LB_BORROW = "PUPUP/LB_BORROW";
export const WALLET_CONFIRM = "POPUP/WALLET_CONFIRM";
export const CONFIRM = "POPUP/CONFIRM";
export const FARM_CLAIM = "POPUP/FARM_CLAIM";
export const FARM_PAGE = "POPUP/FARM_PAGE";
export const FARM_PAGE_COHORT = "POPUP/FARM_PAGE_COHORT";
export const FARM_DW = "POPUP/FARM_DW";
export const REMOVE_LIQUIDITY = "POPUP/REMOVE_LIQUIDITY";
export const CLOSE_POPUP = "POPUP/CLOSE_POPUP";
export const SWAP_SUPPLY = "POPUP/SWAP_SUPPLY";
export const APPROVE = "POPUP/APPROVE";
export const APPROVE_DEPOSIT = "POPUP/APPROVE_DEPOSIT";
export const BUY = "POPUP/BUY";
export const MAX = "POPUP/MAX";
export const CONNECT_WALLET = "POPUP/CONNECT_WALLET";
